<script setup>
import moment from "moment";
</script>
<template>
  <DefaultLayout>
    <v-row class="mx-5 mt-5">
      <v-col cols="12">
        <div
          class="bg-red-ss rounded-top-10 w-100 border border-1 pt-2"
          style="min-height: 5vh"
        >
          <div style="color: #28293d" class="flex items-center mb-2">
            <button @click="$router.back()" class="btn">
              <font-awesome-icon
                icon="fa-solid fa-arrow-left"
                style="color: #28293d"
              />
            </button>
            Dokumen Pra-Presentasi PJP Baru
          </div>
          <div
            class="bg-white rounded-top-10 w-100 border border-1 shadow-sm p-2"
            style="min-height: 60vh"
          >
            <div class="row">
              <div
                class="col-md-6 d-flex justify-content-start"
                style="padding-left: 2rem; padding-top: 0.5rem"
              >
                <img
                  src="../../assets/images/borneo-indobara-icon.png"
                  alt=""
                  style="width: 15%; height: auto"
                />
              </div>
              <div
                class="col-md-6 d-flex justify-content-end"
                style="padding-right: 2rem; padding-top: 0.5rem"
              >
                <p class="fs-5 fw-bold" style="">BIB-HSE-PPO-F-096-02</p>
              </div>
            </div>
            <div class="container p-4">
              <h1 class="text-center mb-3 font-inter font-bold text-3xl">
                SURAT PERMOHONAN PENGESAHAN PJO
              </h1>
              <p
                class="text-center fs-8 mb-3"
                style="font-family: 'Inter-Regular'"
              >
                Formulir ini digunakan untuk membuat permohonan pengesahan calon
                PJO yang diajukan oleh perusahaan jasa/ mitra kerja di PT Borneo
                Indobara
              </p>
              <form action="#" @submit.prevent="preventSubmit">
                <div class="row mb-2">
                  <div class="col-md-3">&nbsp;</div>
                  <div class="col-md-6">
                    <p for="nomor" class="form-label text-center fs-8 fw-bold">
                      Nomor <span class="text-danger fs-6">*</span>
                    </p>
                    <input
                      type="text"
                      class="form-control fs-9"
                      id="nomor"
                      placeholder="Masukkan Nomor Anda"
                      v-model="formValues.noSertifikat"
                      :disabled="statusSio != 0 && statusSio != -3"
                    />
                  </div>
                  <div class="col-md-3">&nbsp;</div>
                </div>
                <p class="fs-8 mb-2" style="font-family: 'Inter-Regular'">
                  Yang bertanda tangan di bawah ini:
                </p>
                <!-- form di sini -->

                <div class="row mb-2">
                  <div class="col-md-6">
                    <label for="nama" class="form-label fs-8 fw-bold"
                      >Nama <span class="text-danger fs-6">*</span></label
                    >
                    <input
                      type="text"
                      class="form-control fs-9"
                      id="nama"
                      placeholder="Masukkan Nama Pimpinan Tertinggi perusahaan"
                      v-model="formValues.namaPemimpin"
                      :disabled="
                        (statusSio != 0 && statusSio != -3) ||
                        formValues.namaPemimpin != null
                      "
                    />
                  </div>
                </div>
                <div class="row mb-2">
                  <div class="col-md-6">
                    <label for="jabatan" class="form-label fs-8 fw-bold"
                      >Jabatan <span class="text-danger fs-6">*</span></label
                    >
                    <input
                      type="text"
                      class="form-control fs-9"
                      id="jabatan"
                      placeholder="Masukkan Jabatan Pimpinan Tertinggi perusahaan"
                      v-model="formValues.jabatanPemimpin"
                      :disabled="
                        (statusSio != 0 && statusSio != -3) ||
                        formValues.jabatanPemimpin != null
                      "
                    />
                  </div>
                </div>
                <p class="fs-8 mb-2">
                  Mohon kepada Kepala Teknik Tambang PT Borneo Indobara untuk
                  mengesahkan orang sebagai berikut:
                </p>
                <div class="row mb-2">
                  <div class="col-md-6">
                    <label for="nama" class="form-label fs-8 fw-bold"
                      >Nama <span class="text-danger fs-6">*</span></label
                    >
                    <input
                      type="text"
                      class="form-control fs-9"
                      id="nama"
                      placeholder="Masukkan Nama Anda"
                      v-model="formValues.nama"
                      :disabled="
                        (statusSio != 0 && statusSio != -3) ||
                        formValues.nama != null
                      "
                    />
                  </div>
                </div>
                <div class="row mb-2">
                  <div class="col-md-6">
                    <label for="jabatan" class="form-label fs-8 fw-bold"
                      >Jabatan <span class="text-danger fs-6">*</span></label
                    >
                    <input
                      type="text"
                      class="form-control fs-9"
                      id="jabatan"
                      placeholder="Masukkan Jabatan Anda"
                      v-model="formValues.jabatan"
                      :disabled="
                        (statusSio != 0 && statusSio != -3) ||
                        formValues.jabatan != null
                      "
                    />
                  </div>
                </div>
                <p class="fs-8">
                  Untuk disahkan sebagai
                  <b>Penanggung Jawab Operasional (PJO)</b> di PT/CV
                </p>
                <div class="col-md-6">
                  <input
                    type="text"
                    class="form-control fs-9"
                    id="perusahaan"
                    placeholder="Masukkan Perusahaan Anda"
                    v-model="formValues.perusahaan"
                    disabled="disabled"
                  />
                </div>
                <p class="fs-8 mt-2">
                  Bersama ini kami lampirkan dokumen pendukung meliputi:
                </p>
                <div class="text-xs">
                  <ol
                    type="1"
                    class="list-decimal font-inter ml-7 my-4"
                  >
                    <li>
                      Penunjukan PJO oleh pimpinan tertinggi perusahaan jasa
                      pertambangan.
                    </li>
                    <li>Dokumen legalitas perusahaan.</li>
                    <li>
                      Salinan IUJP untuk perusahaan jasa pertambangan inti atau
                      izin yang dikeluarkan oleh instansi terkait untuk
                      perusahaan jasa pertambangan non inti.
                    </li>
                    <li>
                      Struktur organisasi perusahaan yang menggambarkan posisi
                      PJO yang ditandatangani oleh pemimpin tertinggi perusahaan
                      dan diberi cap basah perusahaan.
                    </li>
                    <li>
                      Surat pernyataan bermaterai yang ditandatangani oleh
                      pemimpin tertinggi perusahaan yang disebutkan dalam
                      dokumen perusahaan yang menyatakan mendukung semua program
                      kegiatan calon PJO dalam mengimplementasikan KepMen 1827 K
                      /30/MEM/2018 dan penerapan Sistem Manajemen Keselamatan
                      Penambangan (SMKP).
                    </li>
                    <li>
                      Surat pernyataan komitmen PJO dalam melaksanakan peraturan
                      perundangan-undangan dan Sistem Managemen Keselamatan
                      Pertambangan.
                    </li>
                    <li>
                      Daftar riwayat hidup calon PJO (bukti lampiran sertifikat
                      kompetensi, pengalaman kerja minimal 3 tahun dalam posisi
                      yang sama).
                    </li>
                    <li>
                      Calon PJO wajib memiliki kompetensi minimal POP atau yang
                      diminta khusus KTT berdasarkan pertimbangan KPLH dan IBPR
                      bisnis proses.
                    </li>
                    <li>
                      Salinan pengesahan calon PJO apabila sebelumnya sudah
                      pernah disahkan menjadi PJO.
                    </li>
                    <li>
                      Surat keberadaan domisili bagi calon PJO untuk tinggal di
                      jobsite dan tidak boleh dilakukan secara remote.
                    </li>
                    <li>
                      Surat pernyataan bermaterai tentang kebenaran dokumen yang
                      ditandatangani oleh pemohon.
                    </li>
                  </ol>
                </div>

                <p class="mb-3 fs-8 font-inter">
                  Demikian surat permohonan ini kami sampaikan, atas perhatian
                  dan pengesahan yang diberikan kami sampaikan terima kasih.
                </p>

                <div class="row mb-3">
                  <div class="col-md-3">
                    <label for="tempat" class="form-label fs-8 fw-bold"
                      >Tempat <span class="text-danger fs-6">*</span></label
                    >
                    <input
                      type="text"
                      class="form-control fs-9"
                      id="tempat"
                      placeholder="Masukkan Tempat"
                      v-model="formValues.tempat"
                      :disabled="statusSio != 0 && statusSio != -3"
                    />
                  </div>
                  <div class="col-md-3">
                    <label for="tanggal" class="form-label fs-8 fw-bold"
                      >Tanggal <span class="text-danger fs-6">*</span></label
                    >
                    <datepicker
                      v-model="formValues.tanggal"
                      value=""
                      name="tanggal"
                      placeholder="Pilih Tanggal"
                      class="form-control fs-9"
                      input-class="fw-bold"
                      format="yyyy-MM-dd"
                      :disabled="statusSio != 0 && statusSio != -3"
                    ></datepicker>
                  </div>
                </div>

                <div class="row mb-2">
                  <div class="col-md-6">
                    <label for="tandaTangan" class="form-label fs-8 fw-bold">
                      Tanda Tangan (png, jpg, jpeg)
                      <span class="text-danger fs-6">*</span>
                    </label>
                    <div v-if="fileTtd != ''" class="fs-8 mb-2">
                      <img :src="fileTtd" style="height: 5rem" />
                    </div>
                    <div
                      class="input-group mb-1"
                      :hidden="
                        (statusSio != 0 && statusSio != -3) || fileTtd != ''
                      "
                    >
                      <input
                        type="file"
                        ref="tandaTangan"
                        accept="image/png, image/jpg, image/jpeg"
                        class="form-control fs-9"
                        id="inputGroupFile04"
                        @change="handleChangeFile('tandaTangan')"
                        aria-describedby="inputGroupFileAddon04"
                        aria-label="Upload"
                      />
                      <button
                        class="btn btn-outline-secondary fs-9 border border-start-0"
                        type="button"
                        id="inputGroupFileAddon04"
                      >
                        <font-awesome-icon
                          icon="fa-solid fa-cloud-arrow-up"
                          style="color: #000000"
                        />
                      </button>
                    </div>
                    <div
                      v-if="validasiFile.size"
                      class="fs-8 text-danger fst-italic"
                    >
                      Ukuran file melebihi batas (Max: {{ max_file_size }}MB)
                    </div>
                    <div
                      v-if="validasiFile.type"
                      class="fs-8 text-danger fst-italic"
                    >
                      Ekstensi file tidak sesuai, Mohon tambahkan file Gambar
                      png, jpg, jpeg
                    </div>
                  </div>
                </div>
                <div class="row mb-3">
                  <div class="col-md-6">
                    <label for="namaPimpinan" class="form-label fs-8 fw-bold"
                      >Nama Lengkap
                      <span class="text-danger fs-6">*</span></label
                    >
                    <input
                      type="text"
                      class="form-control fs-9"
                      id="namaPimpinan"
                      placeholder="Masukkan Nama Lengkap"
                      v-model="formValues.namaTTD"
                      :disabled="
                        (statusSio != 0 && statusSio != -3) ||
                        formValues.namaTTD != null
                      "
                    />
                    <label for="jabatanTertingi" class="form-label fs-8 fw-bold"
                      >Pimpinan Tertinggi Perusahaan</label
                    >
                  </div>
                </div>
                <div class="row">
                  <div class="col-md-6">
                    <p class="text-danger fst-italic fs-8 fw-bold">
                      * Wajib diisi
                    </p>
                  </div>
                  <div class="col-md-6 d-flex justify-content-end">
                    <button
                      type="button"
                      @click="clickSimpan()"
                      class="btn btn_cari w-50"
                      :hidden="statusSio != 0 && statusSio != -3"
                      :disabled="disabled"
                    >
                      {{
                        statusSio == 0
                          ? "Submit"
                          : statusSio == -3
                          ? "Submit Ulang"
                          : "Submit"
                      }}
                    </button>
                  </div>
                </div>
              </form>
            </div>
          </div>
        </div>
      </v-col>
    </v-row>
  </DefaultLayout>

  <!-- Loading overlay -->
  <div v-if="isLoading" class="loading-overlay">
    <!-- You can customize the loading content here (e.g., a spinner) -->
    <div>
      <img
        src="../../assets/icons/Spinner-1s-200px.svg"
        style="height: 10rem"
        alt=""
      />
    </div>
  </div>
</template>
<style scoped>
section .vuejs3-datepicker__calendar-topbar {
  min-height: auto;
}

.vuejs3-datepicker__value {
  font-size: 0.7rem !important;
  border: 0px !important;
  padding: 0px !important;
}

.vuejs3-datepicker__icon svg {
  height: 0.8rem;
}

.vuejs3-datepicker__content {
  font-size: 0.8rem !important;
  margin-left: 0.3rem !important;
  margin-bottom: -1rem !important;
}

.loading-overlay {
  position: fixed;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  background: rgba(255, 255, 255, 0.8);
  /* Semi-transparent white overlay */
  display: flex;
  justify-content: center;
  align-items: center;
  z-index: 1000;
  /* Make sure it's above other elements on the page */
}

.loading-spinner {
  /* Add your loading spinner styles here */
  border: 4px solid #f3f3f3;
  border-top: 4px solid #3498db;
  border-radius: 50%;
  width: 40px;
  height: 40px;
  /* animation: spin 1s linear infinite; */
}

/* @keyframes spin {
  0% { transform: rotate(0deg); }
  100% { transform: rotate(360deg); }
} */
</style>

<script>
// import router from "../router";
// import SidebarComponent from "@/components/SideBar.vue"
import GlobalDataMixin from "../../GlobalDataMixin";
import Datepicker from "vuejs3-datepicker";

import axios from "axios";
import Swal from "sweetalert2";

import {
  API_BASE_URL,
  CMS_SIO_SET_PJOPENGESAHAN,
  CMS_SIO_GET_PJOPENGESAHAN,
  CMS_UPLOAD_USECASE,
  CMS_DOWNLOAD,
  CMS_SIO_GET_DASHBOARD,
  CMS_GET_KELENGKAPAN_SIO,
  CMS_VIEW_IMAGE,
  CMS_GET_SIOID,
} from "../../constants.js";

const url_simpan = API_BASE_URL + CMS_SIO_SET_PJOPENGESAHAN;
const url_get_pjopengesahan = API_BASE_URL + CMS_SIO_GET_PJOPENGESAHAN;
const url_upload_usecase = API_BASE_URL + CMS_UPLOAD_USECASE;
const url_get_siodashboard = API_BASE_URL + CMS_SIO_GET_DASHBOARD;
const url_get_sioid = API_BASE_URL + CMS_GET_SIOID;
const url_get_kelengkapan = API_BASE_URL + CMS_GET_KELENGKAPAN_SIO;

const url_download = API_BASE_URL + CMS_DOWNLOAD;
const max_file_size = 5; // MB

import DefaultLayout from "@/layouts/DefaultLayout.vue";

export default {
  mixins: [GlobalDataMixin],
  name: "FormSuratPermohonanPengesahanPJO",
  components: { DefaultLayout, Datepicker },
  data() {
    return {
      sioID: null,
      idKelengkapan: null,
      isLoading: false,
      refIDForm: 1,
      idForm: null,
      formValues: {
        namaPemimpin: "",
        jabatanPemimpin: "",
        nama: "",
        perusahaan: "",
        jabatan: "",
        kompetensi: "",
        noSertifikat: "",
        pjo: "",
        tempat: "",
        tanggal: moment(new Date()).format("YYYY-MM-DD"),
        tandaTangan: "",
        namaTTD: "",
        ttd: "",
      },
      fileTtd: "",
      url_icon: "",
      validasiFile: {
        type: false,
        size: false,
      },
      statusSio: 0,
      kontraktorID: null,
      disabled: false
    };
  },
  mounted() {
    this.kontraktorID = parseInt(this.userData.kontraktorID);
    if (localStorage.getItem("sio_cms") != null) {
      this.sioID = JSON.parse(localStorage.getItem("sio_cms")).id;
      this.getSioDashboard(this.sioID);
      this.getSioID(this.kontraktorID);
      this.getKelengkapan(this.sioID);
    }

    if (localStorage.getItem("icon_kontraktor_cms") != null) {
      this.url_icon =
        API_BASE_URL +
        CMS_VIEW_IMAGE +
        JSON.parse(localStorage.getItem("icon_kontraktor_cms")).icon;
    }

    this.formValues.perusahaan =
      this.userData.kontraktorName != null
        ? this.userData.kontraktorName
        : null;
    this.formValues.pjo = "Penanggung Jawab Operasional (PJO)";
    // console.log(localStorage.getItem('sio_cms'))
  },
  methods: {
    preventSubmit() {
      console.log("prevent submit");
    },
    getSioDashboard(sio_id) {
      axios
        .get(url_get_siodashboard + sio_id, {
          headers: {
            role: this.userData.role,
            Authorization: "Bearer " + this.userData.token,
            accept: "*/*",
          },
        })
        .then((response) => {
          console.log(response);
          // this.kontraktor = response.data.detailKontraktor
          // // set value form edit
          // this.formValues.namaKontraktor = this.kontraktor.namaKontraktor
          let ret_dash = response.data.data;
          if (ret_dash.length > 0) {
            for (let i = 0; i < ret_dash.length; i++) {
              // this.onChangeArr(this.listDokumen,'statusFile',ret_dash[i].formStatus, ret_dash[i].id);
              if (ret_dash[i].idForm == this.refIDForm) {
                this.idForm = ret_dash[i].id;
                this.getPJOPengesahan(ret_dash[i].id);
              }
            }
          }
          // this.isLoading = false;
        })
        .catch((error) => {
          this.isLoading = false;
          alert("Error Fetch Data getSioDashboard : " + error.message);
          console.error("Error fetching data getSioDashboard :", error.message);
        });
    },

    getPJOPengesahan(idform) {
      axios
        .get(url_get_pjopengesahan + idform, {
          headers: {
            role: this.userData.role,
            Authorization: "Bearer " + this.userData.token,
            accept: "*/*",
          },
        })
        .then((response) => {
          console.log("getPJOPengesahan", response);
          let dt = response.data.data;

          if (dt != null) {
            // this.formValues.nama = dt.nama==null?'':dt.nama;
            // this.formValues.jabatan = dt.jabatan==null?'':dt.jabatan;
            // this.formValues.namaPemimpin = dt.namaPemimpin==null?'':dt.namaPemimpin;
            // this.formValues.jabatanPemimpin = dt.jabatanPemimpin==null?'':dt.jabatanPemimpin;
            this.formValues.kompetensi =
              dt.kompetensi == null ? "" : dt.kompetensi;
            this.formValues.noSertifikat =
              dt.noRegistrasi == null ? "" : dt.noRegistrasi;
            this.formValues.tempat = dt.tempat == null ? "" : dt.tempat;
            this.formValues.tanggal =
              dt.tanggalTtd != null
                ? moment(dt.tanggalTtd).format("YYYY-MM-DD")
                : null;
            // if(dt.tandaTangan!=''&&dt.tandaTangan!=null){
            //     this.fileTtd = API_BASE_URL + CMS_VIEW_IMAGE + dt.tandaTangan;
            // }

            // this.formValues.namaTTD = dt.namaPengesah==null?'':dt.namaPengesah;
          }
          this.isLoading = false;
        })
        .catch((error) => {
          this.isLoading = false;
          alert("Error Fetch Data getSioDashboard : " + error.message);
          console.error("Error fetching data getSioDashboard :", error.message);
        });
    },

    async simpanForm() {
      this.disabled = true
      const tandaTangan = this.$refs.tandaTangan.files[0];
      this.formValues.ttd = tandaTangan;
      let bodyJsonProfile = {};
      if (this.idForm != null) {
        bodyJsonProfile = {
          id: this.idForm,
          idSio: this.sioID,
          kontraktorId: this.userData.kontraktorID,
          noRegistrasi: this.formValues.noSertifikat,
          tempat: this.formValues.tempat,
          tanggalTtd:
            this.formValues.tanggal != null && this.formValues.tanggal != ""
              ? moment(this.formValues.tanggal).format("YYYY-MM-DD")
              : null,
          // "tandaTangan": "string",
          namaPengesah: this.formValues.namaTTD,
          nama: this.formValues.nama,
          jabatan: this.formValues.jabatan,
          //"kompetensi": this.formValues.kompetensi
          namaPemimpin: this.formValues.namaPemimpin,
          jabatanPemimpin: this.formValues.jabatanPemimpin,
          reason: "",
        };
      } else {
        bodyJsonProfile = {
          // "id": 0,
          idSio: this.sioID,
          kontraktorId: this.userData.kontraktorID,
          noRegistrasi: this.formValues.noSertifikat,
          tempat: this.formValues.tempat,
          tanggalTtd:
            this.formValues.tanggal != null && this.formValues.tanggal != ""
              ? moment(this.formValues.tanggal).format("YYYY-MM-DD")
              : null,
          // "tandaTangan": "string",
          namaPengesah: this.formValues.namaTTD,
          nama: this.formValues.nama,
          jabatan: this.formValues.jabatan,
          kompetensi: null,
          namaPemimpin: this.formValues.namaPemimpin,
          jabatanPemimpin: this.formValues.jabatanPemimpin,
          reason: "",
        };
      }

      await axios
        .post(url_simpan, bodyJsonProfile, {
          headers: {
            role: this.userData.role,
            Authorization: "Bearer " + this.userData.token,
            accept: "*/*",
          },
        })
        .then((response) => {
          console.log("response simpanForm : ", response);
          // console.log("data : ", response.data)

          let idform = response.data.id;
          //convert base64 to filename
          // let filex = null
          if (this.formValues.ttd != "" && this.formValues.ttd !== undefined) {
            // let file  = this.dataURLtoFile(this.formValues.ttd, 'ttd_form1.png');
            // console.log('file = ',file)
            this.uploadFile(tandaTangan, idform);
          } else {
            this.alertSukses();
          }
        })
        .catch((error) => {
          console.log("error simpanForm : ", error);
          alert("error simpanForm");
          // if(error.response.status==500){
          //     alert("Error "+error.response.status+" simpanAddSubKontraktor : " + error.response.data.status.message)
          // }else if(error.response.status==400){
          //     alert("Error "+error.response.status+" simpanAddSubKontraktor : " + error.response.data.status.message)
          // }else if(error.response.status==401){
          //     alert("Error "+error.response.status+" simpanAddSubKontraktor : " + error.response.data.status.message)
          // }
        })
        .then(() => {});
    },

    async uploadFile(file, idform) {
      if (file) {
        // Get the file name
        const fileName = file.name;

        // Create a FormData object and append the file
        const formData = new FormData();
        formData.append("file", file);
        formData.append("id", idform);
        formData.append("purpose", "form1");
        formData.append("usecase", "ttd_form1");

        // Make the API request to upload the file
        try {
          const response = await axios.post(url_upload_usecase, formData, {
            headers: {
              "Content-Type": "multipart/form-data",
              role: this.userData.role,
              Authorization: "Bearer " + this.userData.token,
              accept: "*/*",
            },
          });

          // Handle the response from the server as needed
          console.log("File upload response:", response.data);
          console.log("filename : ", fileName);

          this.alertSukses();
        } catch (error) {
          // Handle errors, e.g., display an error message to the user
          alert(error.message);
          if (error.response.data != null) {
            alert(error.response.data.message);
          }
          this.isLoading = false;
          console.error("Error uploading file:", error);
          // this.$router.go(this.$router.currentRoute)
        }
      }
    },

    //return a promise that resolves with a File instance
    dataURLtoFile(dataurl, filename) {
      var arr = dataurl.split(","),
        mime = arr[0].match(/:(.*?);/)[1],
        bstr = atob(arr[1]),
        n = bstr.length,
        u8arr = new Uint8Array(n);
      while (n--) {
        u8arr[n] = bstr.charCodeAt(n);
      }
      return new File([u8arr], filename, { type: mime });
    },

    handleChangeFile(refFile) {
      let file = null;
      if (refFile == "tandaTangan") {
        file = this.$refs.tandaTangan.files[0];
      }
      console.log("Valid file:", file);
      if (file) {
        // Check file type
        if (
          file.type !== "image/jpg" &&
          file.type !== "image/jpeg" &&
          file.type !== "image/png"
        ) {
          this.validasiFile.type = true;
          this.validasiFile.size = false;
          this.$refs.tandaTangan.value = "";
          return;
        }

        // Check file size ({{max_file_size}}MB limit)
        if (file.size > max_file_size * 1024 * 1024) {
          this.validasiFile.type = false;
          this.validasiFile.size = true;
          this.$refs.tandaTangan.value = "";
          return;
        }

        // Reset error messages if the file is valid
        this.validasiFile.type = false;
        this.validasiFile.size = false;

        // Handle the valid file as needed (e.g., store the file)
        console.log("Valid file:", file);
      }
    },

    clickSimpan() {
      this.isLoading = true;
      if (this.validasiForm()) {
        this.simpanForm();
      } else {
        alert("Lengkapi pengisian form !");
        this.isLoading = false;
      }
    },
    validasiForm() {
      if (
        this.formValues.noSertifikat.trim() != "" &&
        this.formValues.nama != "" &&
        this.formValues.jabatan != "" &&
        this.formValues.namaPemimpin != "" &&
        this.formValues.jabatanPemimpin != "" &&
        this.formValues.tempat.trim() != "" &&
        this.formValues.tanggal != "" &&
        this.formValues.namaTTD != "" &&
        (this.fileTtd != "" || this.$refs.tandaTangan.value != "")
      ) {
        return true;
      } else {
        return false;
      }
    },
    alertSukses() {
      Swal.fire({
        title: "Simpan Form Sukses",
        text: "Surat Permohonan Pengesahan PJO Berhasil disimpan !",
        icon: "success",
        showConfirmButton: false,
        timer: 2000,
        showClass: {
          popup: "animate__animated animate__fadeInDown",
        },
        hideClass: {
          popup: "animate__animated animate__fadeOutUp",
        },
      }).then(() => {
        this.$router.back();
      });
    },

    downloadFile(filename) {
      axios
        .get(url_download + filename, { responseType: "blob" })
        .then((response) => {
          this.handleFileDownload(response.data, filename);
        })
        .catch((error) => {
          console.error("Error downloading file:", error);
        });
    },
    handleFileDownload(blobData, filename) {
      // Create a Blob from the response data
      const blob = new Blob([blobData], { type: "application/octet-stream" });
      console.log("blob nya = ", blob);
      // Create a link element and trigger a download
      const link = document.createElement("a");
      link.href = window.URL.createObjectURL(blob);
      link.download = filename; // Set the desired file name
      link.click();
    },
    getSioID(id) {
      axios
        .get(url_get_sioid + id, {
          headers: {
            role: this.userData.role,
            Authorization: "Bearer " + this.userData.token,
            accept: "*/*",
          },
        })
        .then((response) => {
          this.statusSio = response.data.data.status;
          this.isLoading = false;
        })
        .catch((error) => {
          this.isLoading = false;
          alert("Error Fetch Data getSioID : " + error.message);
          console.error("Error fetching data getSioID :", error.message);
        });
    },

    getKelengkapan(sio_id) {
      axios
        .get(url_get_kelengkapan + sio_id, {
          headers: {
            role: this.userData.role,
            Authorization: "Bearer " + this.userData.token,
            accept: "*/*",
          },
        })
        .then((response) => {
          console.log(response);
          // this.kontraktor = response.data.detailKontraktor
          // // set value form edit
          // this.formValues.namaKontraktor = this.kontraktor.namaKontraktor
          let ret_kel = response.data;
          this.idKelengkapan = ret_kel.id == null ? "" : ret_kel.id;
          this.formValues.nama = ret_kel.namaPjo == null ? "" : ret_kel.namaPjo;
          this.formValues.jabatan =
            ret_kel.jabatanPjo == null ? "" : ret_kel.jabatanPjo;
          this.formValues.namaTTD =
            ret_kel.namaAtasan == null ? "" : ret_kel.namaAtasan;
          this.formValues.namaPemimpin =
            ret_kel.namaAtasan == null ? "" : ret_kel.namaAtasan;
          this.formValues.jabatanPemimpin =
            ret_kel.jabatanAtasan == null ? "" : ret_kel.jabatanAtasan;

          // this.formValues.jabatanAtasan = ret_kel.jabatanAtasan;
          // this.formValues.fileTtdPjo = ret_kel.ttdPjo;
          if (ret_kel.ttdAtasan != "" && ret_kel.ttdAtasan != null) {
            this.fileTtd = API_BASE_URL + CMS_VIEW_IMAGE + ret_kel.ttdAtasan;
          }
        })
        .catch((error) => {
          this.isLoading = false;
          alert("Error Fetch Data getKelengkapan : " + error.message);
          console.error("Error fetching data getKelengkapan :", error.message);
        });
    },
  },
};
</script>
